module.exports = __webpack_public_path__ + "assets/terms/termos-cl.5cb65b1d.pdf";